import { render, staticRenderFns } from "./SorList.vue?vue&type=template&id=1de05093"
import script from "./SorList.vue?vue&type=script&lang=js"
export * from "./SorList.vue?vue&type=script&lang=js"
import style0 from "./SorList.vue?vue&type=style&index=0&id=1de05093&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports